module.exports = __webpack_public_path__ + "static/media/Inter-BoldItalic.d7b76952.woff2";